/**
 * Created by Languagenut on 21/03/2019.
 */

import React from 'react'
import {
    HashRouter as Router,
    Route,
    Redirect,
} from 'react-router-dom'
import InternationalizationService from './services/internationalization-service.js';
import Translation from './store/internationalization-store.js';

import {
    Logins, EditContent, Students, StudentAdministration, StudentManagement, ClassManagement, SchoolDashboard, Content, Assignments, Staff,
    Missing, ReportsScreen, Help, Authentication, Classes, Account, Settings, Libaray, ExamTests, ExamTestsMinor
} from './screens';
import { ParentAuthentication } from './screens/parent_portal';

import { Navigation } from './components';
import { AuthenticationStore } from './store';
import HelpVideos from './components/help-videos.js';



class PrivateRoute extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {

        }
    }

    getRedirection() {

        let Setup = "/account/setup"



        return this.props.path != Setup ? Setup : 'allowed'
    }

    getRedirectionComponent(props) {

        let Component = this.props.component;


        if (AuthenticationStore.isAuthenticated()) {

            switch (this.getRedirection()) {
                case "/account/setup":
                    //   return <Redirect to='/account/setup' />
                    break;
            }

            return <Component {...props} />
        }


        return <Redirect to='/' />
    }

    render() {
        return <Route exact={this.props.exact} path={this.props.path} render={(props) => (this.getRedirectionComponent(props))} />
    }
}



export default class ApplicationRouter extends React.Component {

    constructor(props) {
        super();
        this.state = {
            gotTranslations: false,
            authenticated: false
        }
    }

    componentWillMount() {
        Translation.on('ON_TRANSLATION_UPDATE', () => {

            this.setState({
                gotTranslations: true
            })
        })
    }

    componentDidMount() {
        InternationalizationService.getTranslations();
        InternationalizationService.getModuleTranslations();
    }

    router() {

        this.href = window.location.href;
        this.href.substring(this.href.lastIndexOf('/') + 1);


        switch (this.href) {
            case "parents": return this.getEstablishmentParentalAdministration();
            case "admin":
            default:
                return this.getEstablishmentAdministration();
        }

    }

    getEstablishmentParentalAdministration() {
        return <div class="container" style={{ paddingTop: "20px" }}>
            <Route exact path="/" component={ParentAuthentication} />
        </div>
    }

    getEstablishmentAdministration() {

        return <div class="container" style={{ paddingTop: "20px" }}>
            <Route exact path="/" component={Authentication} />
            <Route exact path="/LoginScreen/:token" component={Authentication} />
            <PrivateRoute exact path="/school/dashboard" component={SchoolDashboard} />
            <PrivateRoute exact path="/assignments/:tab" component={Assignments} />
            <PrivateRoute exact path="/classes/:tab/:id" component={Classes} />
            <PrivateRoute exact path="/classes/:tab/:id/:action" component={Classes} />
            <PrivateRoute exact path="/classes/:tab/:id/report/:reportID" component={Classes} />
            <PrivateRoute exact path="/classes/:tab/:id/report/:reportID/:language/:screenID" component={Classes} />
            <PrivateRoute exact path="/students/:tab/:id" component={Students} />
            <PrivateRoute exact path="/students/:tab/:id/:action" component={Students} />
            <PrivateRoute exact path="/students/:tab/:id/report/:reportID" component={Students} />
            <PrivateRoute exact path="/students/:tab/:id/report/:reportID/:language/:screenID" component={Students} />
            <PrivateRoute exact path="/account" component={Account} />
            <PrivateRoute exact path="/reports/:level/:id/:reportID" component={ReportsScreen} />
            <PrivateRoute exact path="/reports/:level/:id/:reportID/:language" component={ReportsScreen} />
            <PrivateRoute exact path="/settings/:tab" component={Settings} />
            <PrivateRoute exact path="/library/:tab" component={Libaray} />
            <PrivateRoute exact path="/help/" component={Help} />
            <PrivateRoute exact path="/staff/" component={Staff} />
            <PrivateRoute exact path="/missing/:type" component={Missing} />
            <PrivateRoute exact path="/error/:code" component={Missing} />
            <PrivateRoute exact path="/content/:tab" component={Content} />
            <PrivateRoute exact path="/content/:tab/edit/:id" component={EditContent} />
            <PrivateRoute exact path="/class/management" component={ClassManagement} />
            <PrivateRoute exact path="/student/management" component={StudentManagement} />
            <PrivateRoute exact path="/student/administration" component={StudentAdministration} />
            <PrivateRoute exact path="/examTests/list" component={ExamTests} />
            <PrivateRoute exact path="/examTests/minor/:studentUid/:testUid" component={ExamTestsMinor} />
            <PrivateRoute exact path="/assignments/:tab/:homeworkID" component={Assignments} />
            <PrivateRoute exact path="/assignments/:tab/:homeworkID/:curriculumID" component={Assignments} />
            <PrivateRoute exact path="/assignments/:tab/:homeworkID/:curriculumID/:languageID" component={Assignments} />
            <PrivateRoute exact path="/logins" component={Logins} />
            <PrivateRoute exact path="/videos/helpVideos" component={HelpVideos} />
        </div>
    }

    render() {
        if (!this.state.gotTranslations) return null;
        return <Router>
            <Navigation />
            {this.router()}
        </Router>

    }
}
